import React, { useEffect, useState } from 'react';
import { Row, Col, Button, message, Space, Popconfirm } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerList } from '../ducks/actions'
import { removeCustomer, bulkRemoveCustomers } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search'
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { useTranslate } from 'Translate';

export default (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.crm.customers);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const i18n = useTranslate();
    const { t } = i18n;

  const colName = [
    {
      title: t("Crm.first_name"),
      dataIndex: 'first_name',
      key: 'first_name',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Crm.last_name"),
      dataIndex: 'last_name',
      key: 'last_name',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Outlet.phone_number"),
      dataIndex: 'phone',
      key: 'phone',
      className: 'enable-click',
      sorter: true,
      render: (text, record) => <span>+{record?.calling_code}{text}</span>
    },
    {
      title: t("System.email"),
      dataIndex: 'email',
      key: 'email',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Crm.gender"),
      dataIndex: 'gender',
      key: 'gender',
      className: 'enable-click',
      sorter: true,
      render: (text) => <span>{text === "M" ? "Male" : text === "F" ? "Female" : text}</span>
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Active" ? "c-success" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {
            allowed([AllRoles.CRM.CUSTOMER], 'write') &&
            <Button type="link" onClick={() => onAction(record.id, text)}>
              {text === "Active" ? `(${t("General.deactivate")})` : `(${t("General.activate")})`}
            </Button>
          }
        </div>
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="customer"
          btnAction1={() => navigate(`/crm/customers/${record.id}`)}
          recordId={record.id}
          onRemove={allowed([AllRoles.CRM.CUSTOMER], 'delete') && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const addNew = () => navigate('/crm/customers/add');

  const btnList = [
    {
      title: t("Confirm.remove_select_customer"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.customer")}`,
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.customerListQuery) {
      dispatch(getCustomerList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('customerListQuery', 1, limit, '', '', null, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.customerListQuery
      dispatch(getCustomerList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onAction = async (customerId, status) => {
    props.setLoading(true);

    const payload = {
      user_id: customerId,
      status_event: status === 'Active' ? 'deactivate' : 'activate'
    }

    await removeCustomer(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_customer_status"));
        setTimeout(() => dispatch(getCustomerList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('customerListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onRemove = async (id) => {
    props.setLoading(true);

    const payload = {
      user_id: id,
      status_event: 'remove'
    }

    await removeCustomer(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_customer"));
        setTimeout(() => dispatch(getCustomerList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('customerListQuery', page, limit, '', '', searchVal, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      customers: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveCustomers(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_customers"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getCustomerList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('customerListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getCustomerList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('customerListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getCustomerList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('customerListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        name: search.name
      };
      setSearchVal(searching);
      dispatch(getCustomerList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('customerListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getCustomerList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('customerListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
          navigate(`/crm/customers/${record.id}`)
      },
    };
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("General.customers")} btnList={allowed([AllRoles.CRM.CUSTOMER], 'write') ? btnList : null} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            searchVal={globalListQuery.customerListQuery?.searchValue}
            onRow={onClickRow}
            // listClass="nopad"
            ListData={customers?.list?.map(x => ({ ...x, key: x.id }))}
            ListCol={colName}
            rowSelection={rowSelection}
            onChange={onTableChange}
            pagination={{
              total: customers?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
    </>
  )
}